var _path, _g, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertDirectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2029_28816)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2029_28816",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 18,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.105469 0.5H16.4727V15.4993H-0.105469V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2029_28816)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.07845 14.7108C0.900828 14.7108 0.745309 14.5924 0.697943 14.4211C0.650577 14.2498 0.723205 14.0682 0.875566 13.9766C2.2105 13.1769 2.7639 12.0125 2.96046 11.467C1.50948 10.3563 0.683594 8.81924 0.683594 7.21116C0.683594 6.39884 0.887407 5.61098 1.29002 4.87049C1.67369 4.16473 2.22155 3.53239 2.91705 2.99084C4.32777 1.89353 6.19794 1.28882 8.18337 1.28882C10.1688 1.28882 12.039 1.89353 13.4497 2.99084C14.1452 3.53239 14.6931 4.16473 15.0767 4.87049C15.4793 5.61098 15.683 6.39726 15.683 7.21116C15.683 8.02349 15.4793 8.80977 15.0767 9.55026C14.6931 10.256 14.1452 10.8884 13.4497 11.4299C12.039 12.5272 10.1688 13.1319 8.18337 13.1319C7.36788 13.1319 6.5674 13.0301 5.80243 12.828C5.46377 13.0546 4.83064 13.454 4.07436 13.8306C2.89968 14.4148 1.89157 14.7108 1.07845 14.7108Z",
    fill: "#E99210",
    stroke: "#E99210",
    strokeWidth: 0.0789436
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18378 8.00059C7.9659 8.00059 7.78906 7.83777 7.78906 7.63876V4.02052C7.78906 3.82007 7.9659 3.65869 8.18378 3.65869C8.40166 3.65869 8.5785 3.82007 8.5785 4.02052V7.63876C8.5785 7.83777 8.40166 8.00059 8.18378 8.00059Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.157887
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18378 10.3674C7.9659 10.3674 7.78906 10.1898 7.78906 9.97273V9.18329C7.78906 8.96462 7.9659 8.78857 8.18378 8.78857C8.40166 8.78857 8.5785 8.96462 8.5785 9.18329V9.97273C8.5785 10.1898 8.40166 10.3674 8.18378 10.3674Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.157887
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2029_28816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertDirectionIcon);
export default __webpack_public_path__ + "static/media/cert_direction_icon.6040fc67939b3e329a42a81acafc4a19.svg";
export { ForwardRef as ReactComponent };